/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Service from 'types/service';
import { dashboard } from 'types';
import {
  resendUpdatePartyStatus,
  updatePartyStatus as updatePosPartyStatus,
} from 'actions/PosActions';
import { safeToNumber, toJSON } from '@tock/coretypes';
import { shouldSendPartyStatusUpdates } from 'utils/service/posUtils';
import AppConstants from 'constants/AppConstants';
import confirm from 'shared/utils/confirm';
import protos from 'utils/protos';

const { PosTableStatusUpdateRequest } = protos;

export const REALTIME_POS_ACTION = 'REALTIME_POS_ACTION_STRING';

export interface RealtimePartyDetails {
  id: number;
  type: string;
  lastNameFirstName: string;
  patronInfo?: Service.ElmPatron;
  phone?: string;
  email?: string;
  partySize?: number;
  partyType: { partyType: 'WalkInParty' | 'PurchaseParty' };
}

export interface RealtimePosRequestData {
  newState: string;
  party: RealtimePartyDetails;
  tables: Service.ServiceTable[];
}

export interface RealtimePosActionReturnType {
  type: 'REALTIME_POS_ACTION_STRING';
  [REALTIME_POS_ACTION]: RealtimePosRequestData;
}

/**
 * Dispatches a request to update the realtime state by making a call to Tock.
 * If the change is not allowed, confirm with the user that the change is wanted.
 */
function updatePosPartyState(store: any, realtimePosRequestData: RealtimePosRequestData) {
  const { newState, party, tables } = realtimePosRequestData;
  store.dispatch(updatePosPartyStatus(party, newState, tables));
}

export default (store: any) => (next: any) => (action: any) => {
  if (action.type === 'APP_STATE_CHANGED') {
    return next(action);
  }

  if (action[REALTIME_POS_ACTION] && shouldSendPartyStatusUpdates(store.getState())) {
    updatePosPartyState(store, action[REALTIME_POS_ACTION]);
  } else if (
    action.type === AppConstants.POS_UPDATE_PARTY_STATUS_FAILED &&
    action.error &&
    safeToNumber(action.error.errorCode) === 3047 // A check already exists
  ) {
    const overrideRequest = PosTableStatusUpdateRequest.fromObject({
      ...toJSON<dashboard.PosTableStatusUpdateRequest>(action.request),
      override: 'ADD_NEW_CHECK',
    });

    confirm
      .show(
        'An order is already associated with this party in the point of sale. Create a new check?'
      )
      .then(() => store.dispatch(resendUpdatePartyStatus(overrideRequest)));
  }

  return next(action);
};
